import React from "react";
import OvAccountsViewContainer from "./OvAccountsViewContainer";

import OvTimeViewContainer from "./OvTimeViewContainer";

import { Route, Switch } from "react-router-dom";

import NoMatch from "./NoMatch";

const OvSectionRouter = props => {
  return (
    <div>
      <Switch>
        <Route
          path="/overview/time"
          render={routerProps => {
            return <OvTimeViewContainer {...routerProps} />;
          }}
        />
        <Route
          path="/overview/accounts"
          render={routerProps => {
            return <OvAccountsViewContainer {...routerProps} />;
          }}
        />
        <Route render={routerProps => <NoMatch {...routerProps} />} />
      </Switch>
    </div>
  );
};

export default OvSectionRouter;



// WEBPACK FOOTER //
// ./src/OvSectionRouter.js